
import { motion } from "framer-motion";

const SolutionSection = () => {
  return (
    <section className="py-20 md:py-28 bg-white" id="solution">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <motion.div
            className="md:order-2"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <span className="px-4 py-2 rounded-full bg-expitrack-primary/10 text-expitrack-primary text-sm font-medium">
              The Solution
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-6">
              ExpiTrack: AI-Powered Expiry Management
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              We've built a comprehensive platform that combines predictive AI with intuitive inventory
              management to help you avoid waste before it happens.
            </p>

            <ul className="space-y-4">
              {[
                "Track inventory and expiration dates in one place",
                "Get predictions and alerts before items expire",
                "Visualize inventory health with smart analytics",
                "Take action with recommendations based on your usage patterns",
                "Save money and reduce environmental impact"
              ].map((feature, index) => (
                <motion.li
                  key={index}
                  className="flex items-start"
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: 0.1 * index }}
                  viewport={{ once: true }}
                >
                  <div className="mr-3 mt-1 w-5 h-5 bg-expitrack-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <svg className="w-3 h-3 text-expitrack-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-gray-700">{feature}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className="md:order-1 relative"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="/uploads/The_solution.png"
                alt="ExpiTrack Dashboard"
                className="w-full rounded-2xl"
              />
            </div>
            <div className="absolute top-10 -left-10 w-72 h-72 bg-expitrack-primary/10 rounded-full filter blur-3xl -z-10"></div>
            <div className="absolute -bottom-10 -right-10 w-72 h-72 bg-blue-500/10 rounded-full filter blur-3xl -z-10"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
